
import Header from './commonResource/Header/header';
import Footer from './commonResource/footer/footer';
import Home from '../src/commonResource/Homesection/home'
function App() {
  return (
    <div>
      <Header />
     <Home/>
      <Footer />
    </div>
  );
}

export default App;
